import PropTypes from 'prop-types';
import React from 'react';
import { Translate } from 'react-localize-redux';
import { TRANSLATE_PREFIX } from '../../consts';
import css from './BulkRemoveUsedParamsBody.css';

const TAB_PREFIX = `${TRANSLATE_PREFIX}.TRACKING_LINK_OPTIONS_TAB`;

const BulkRemoveUsedParamsBody = ({ keys }) => (
    <div className={css.confirmBody}>
        <p>
            <Translate id={`${TAB_PREFIX}.CONFIRM_DIALOG.REMOVE_USED_PARAMS_BULK_TEXT`} />
        </p>
        <div className={css.confirmList}>
            <Translate id={`${TAB_PREFIX}.CONFIRM_DIALOG.REMOVE_USED_PARAMS_BULK_LIST_INTRO`} />
            <ul>
                {keys.map(k => (
                    <li key={k}>{k}</li>
                ))}
            </ul>
        </div>
    </div>
);

BulkRemoveUsedParamsBody.propTypes = {
    keys: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default BulkRemoveUsedParamsBody;
